/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Button,
} from 'reactstrap';

import BaseGrid from '../Common/BaseGrid';

// import { get } from '../../helpers/api_helper';

function ItemSelector(props) {
  const { t, onSelect, openByDefault } = props;

  const [finder, setFinder] = useState(openByDefault);

  const jsx = (
    <div>
      {!finder && (
        <Button size="sm" color="primary" className="btn-soft-primary" onClick={() => { setFinder(true); }}>
          {t('Select an Item')}
        </Button>
      )}

      {finder && (
        <div>
          <BaseGrid
            url="/api/items"
            hasSearch
            config={
              {
                columns: {
                  thumb: {
                    label: '',
                    image: {
                      src: (item) => (`/api/items/thumbnail/${item.id}`),
                      class: 'rounded',
                      style: { maxHeight: '5rem', maxWidth: '5rem' },
                    },
                    translate: false,
                  },
                  id: { label: props.t('ID'), sort: true },
                  manufacturer: { label: props.t('Mnfctr'), sort: true },
                  part_number: { label: props.t('Part Number'), sort: true },
                  actions: {
                    label: props.t('Actions'),
                    actions: [
                      {
                        icon: 'mdi mdi-check',
                        class: 'btn btn-sm btn-soft-primary',
                        tooltip: props.t('Select'),
                        click: (item) => {
                          onSelect(item);
                          setFinder(false);
                        },
                      },
                    ],
                  },
                },
                pagination: {
                  sort: 'id',
                  direction: 'desc',
                  perPage: 4,
                },
              }
            }
          />
        </div>
      )}
    </div>
  );

  return jsx;
}

ItemSelector.defaultProps = {
  onSelect: () => {},
  openByDefault: false,
};

ItemSelector.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSelect: PropTypes.func,
  openByDefault: PropTypes.bool,
};

export default connect(() => ({

}), {})(withTranslation()(ItemSelector));
